import PropTypes from 'prop-types';
import { useContext } from 'react';
import classnames from 'classnames';
import { HeaderFooterServerVarsContext } from '../HeaderFooterServerVarsContext/HeaderFooterServerVarsContext.tsx';

import dibsCss from 'dibs-css';

export const SearchBarSection = ({ title, children }) => {
    const { isMobile } = useContext(HeaderFooterServerVarsContext);
    return (
        <div
            data-tn="search-bar-section"
            className={classnames(
                dibsCss.flex,
                dibsCss.flexCol,
                isMobile ? dibsCss.gapSmaller : dibsCss.gapXxsmall
            )}
        >
            <div
                data-tn="search-bar-header"
                className={classnames(
                    dibsCss.textSubHeaderSmallHeavy,
                    dibsCss.textSatan,
                    dibsCss.mxSmall,
                    dibsCss.borderBSolid,
                    dibsCss.borderB,
                    dibsCss.borderDolphin,
                    isMobile
                        ? [dibsCss.mtLarge, dibsCss.pbXsmall]
                        : [dibsCss.mtSmall, dibsCss.pbXxsmall]
                )}
            >
                {title}
            </div>
            {children}
        </div>
    );
};

SearchBarSection.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
};
